import { useEffect, useRef, useState, Suspense } from 'react';
import styles from './index.module.scss';
import { Layout, Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import HomeHeader from './components/HomeHeader';
import MenuComponent from './components/MenuComponent/index.jsx';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useRootContext } from '@/common/RootContext';
import LoadingComponents from '@/pages/components/LoadingComponent';
import classNames from 'classnames';
import SvgIcon from '@/pages/components/SvgIcon/index.jsx';

const { Header, Sider, Content } = Layout;

function Home({ routerParams }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const rootContentData = useRootContext();
  const { t } = useTranslation();
  const menuTrigger = useRef();
  const [navigationOpen, setNavigationOpen] = useState(false);
  // This page extension uses the existing desktop minimum, not a global layout token.
  const [narrow, setNarrow] = useState(() => window.matchMedia('(max-width: 1023px)').matches);
  const responsive = routerParams?.responsiveManagement === true;

  useEffect(() => {
    const media = window.matchMedia('(max-width: 1023px)');
    const update = () => setNarrow(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  useEffect(() => { setNavigationOpen(false); }, [pathname, narrow, responsive]);

  const onMenuItemClick = item => {
    setNavigationOpen(false);
    rootContentData.eventEmitter?.emit('menu-item-click', { key: item.key, keyPath: item.keyPath });
  };
  const navigation = (
        <div
          className={`${styles.menuContainer} ${styles.noUserHeight}`}
        >

          <div className={styles.log}>
            <SvgIcon
              onClick={() => {
                navigate({
                  pathname: '/'
                })
              }}
              name={"logo"}
              style={{ width: "132px", height: "26px", cursor: 'pointer' }}
            />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              marginBottom: '20px',
            }}
          >
            <Button
              ghost
              onClick={() => {
                window.open(import.meta.env.VITE_APP_JUMP_URL, '_self');
              }}
            >
              {
                t(import.meta.env.VITE_APP_ENV === 'cn' ? 'adminNavigation.internationalSite' : 'adminNavigation.domesticSite')
              }
            </Button>
          </div>

          <MenuComponent onMenuClick={onMenuItemClick} />
        </div>
  );

  return (
    <Layout className={classNames(styles.container, { [styles.responsiveContainer]: responsive })}>
      {responsive && narrow ? (
        <Drawer title={t('agentManagement.navigation')} placement="left" width={220}
          open={navigationOpen} onClose={() => setNavigationOpen(false)} destroyOnClose
          styles={{ body: { padding: 0 } }}
          afterOpenChange={open => { if (!open) menuTrigger.current?.focus({ preventScroll: true }); }}>
          <nav id="maintenance-navigation" aria-label={t('agentManagement.navigation')} className={styles.sider}>
            {navigation}
          </nav>
        </Drawer>
      ) : <Sider className={styles.sider}>{navigation}</Sider>}
      <Layout className={responsive ? styles.responsiveMain : undefined}>
        <Header className={classNames(styles.header, { [styles.responsiveHeader]: responsive && narrow })}>
          {responsive && narrow && <Button ref={menuTrigger} type="text" className={styles.menuToggle}
            icon={<MenuOutlined />} aria-label={t('agentManagement.openNavigation')}
            aria-expanded={navigationOpen} aria-controls="maintenance-navigation"
            onClick={() => setNavigationOpen(true)} />}
          <HomeHeader />
        </Header>
        <Content className={styles.content}>
          <Suspense fallback={<LoadingComponents />}><Outlet /></Suspense>
        </Content>
      </Layout>
    </Layout>
  );
}

export default Home;
